var map = {
	"./Architect.json": 161,
	"./BusinessOwner.json": 75,
	"./ComplianceOfficer.json": 25,
	"./ContentWriter.json": 320,
	"./Customer.json": 138,
	"./DataAnalyst.json": 456,
	"./DevOps.json": 299,
	"./Developer.json": 744,
	"./EndUser.json": 960,
	"./EpicOwner.json": 569,
	"./MarketingManager.json": 781,
	"./ProductManager.json": 852,
	"./ProductOwner.json": 108,
	"./ProjectManager.json": 338,
	"./QALead.json": 110,
	"./ReleaseTrainEngineer.json": 238,
	"./Researcher.json": 376,
	"./SalesRep.json": 649,
	"./ScrumMaster.json": 250,
	"./SecuritySpecialist.json": 605,
	"./SolutionArchitect.json": 436,
	"./Stakeholder.json": 974,
	"./SupportAgent.json": 650,
	"./SystemTeam.json": 730,
	"./TechLead.json": 832,
	"./Tester.json": 461,
	"./UIDesigner.json": 165,
	"./UXDesigner.json": 278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 451;